// extracted by mini-css-extract-plugin
export default {"banner":"banner---Wqbk0","linkButton":"linkButton---LCbhN","warning":"warning---EKIc3"};